import { gql } from '@apollo/client';

const GET_SETTLEMENT_OFFERS = gql`
  query GetSettlementOffers($customerId: String!, $accountId: String!) {
    account(customerId: $customerId, accountId: $accountId) {
      id
      offers {
        eligibility(offerType: SETTLEMENT) {
          checks {
            name
            pass
          }
          eligible
          offerType
        }
        offers(offerType: SETTLEMENT) {
          createdAt
          offerId
          data {
            acceptanceExpiration
            acceptedAt
            atpUnderSIF
            canceledReason
            duration {
              value
              unit
            }
            expiration
            fundingAccountId
            isDebitCardOffer
            offerId
            originalOutstandingBalance
            originalSettlementBalance
            pastPaymentPlanIds
            paymentPlan {
              authorizationText
              customerId
              id
              source
              transactions {
                amount
                date
              }
            }
            payments {
              amount
              date
              txId
              type
            }
            remainingBalance
            state
            subType
            type
          }
        }
        settlement {
          available {
            amount
            durationMonths
            offerId
            offerName
            outstandingBalance
          }
        }
      }
    }
  }
`;

export { GET_SETTLEMENT_OFFERS };
